import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ForecastsHubStore {
  uniqueKpiId: string | undefined;
  setUniqueKpiId: (uniqueKpiId: string | undefined) => void;
}

export const useForecastsHubStore = create<ForecastsHubStore>()(
  persist(
    (set) => ({
      uniqueKpiId: undefined,
      setUniqueKpiId: (uniqueKpiId) => set({ uniqueKpiId }),
    }),
    {
      name: 'forecasts-hub',
    },
  ),
);
